export class ProductType {
    public static Product = 'product';
    public static CNG = 'cng';
    public static Bucket = 'bucket';
    public static SKU = 'sku';

    public static isEcommerceType(type) {
        return type !== this.Bucket;
    }

    public static getRoute(type) {
        switch (type) {
            case this.SKU:
                return this.Bucket;
            case this.CNG:
            case this.Product:
                return type;
            default:
                return this.Product;
        }
    }
}
